import { render, staticRenderFns } from "./CustomerServiceComponent.vue?vue&type=template&id=ff0af5a8&scoped=true"
import script from "./CustomerServiceComponent.vue?vue&type=script&lang=js"
export * from "./CustomerServiceComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceComponent.vue?vue&type=style&index=0&id=ff0af5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0af5a8",
  null
  
)

export default component.exports